import styles from "./style.module.css";
export default function Loader() {
  return (
    <div className={styles.ldsroller}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
